import { createAxiosClient } from '@/shared/libs/axios/createAxiosClient';
import { getUTMHeaders } from '@/shared/libs/axios/utm-headers';
import getEnv from '@/shared/configs/env';

export const DealsDashboardClient = createAxiosClient({
  options: {
    baseURL: getEnv().deals_dashboard_service_url,
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 300000,
  },
});

DealsDashboardClient.interceptors.request.use((config) => {
  Object.entries(getUTMHeaders()).forEach(([name, value]) => {
    config.headers.set(name, value);
  });

  return config;
});
